import React from 'react';

import Box from 'components/Box';
import { LinkButton, PrimaryButton } from 'components/Button';
import { BodySmall, H3 } from 'components/Text';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const IdealistDaysMapAddPinConfirm = ({
  confirmAddPin,
  cancelAddPin,
}: {
  confirmAddPin: () => void;
  cancelAddPin: () => void;
}) => (
  <Box width={['auto', 480]}>
    <H3 textAlign="center">{getText('Add pin here?')}</H3>

    <Box mt={[24, 32]}>
      <PrimaryButton
        width={1}
        data-qa-id="days-map-confirm-add-pin"
        onClick={confirmAddPin}
      >
        {getText('Add')}
      </PrimaryButton>
    </Box>

    <Box display="flex" justifyContent="center" mt={24} mb={12}>
      <LinkButton
        data-qa-id="days-map-cancel-add-pin"
        onClick={cancelAddPin}
        grey
      >
        <BodySmall styleAs="h5">{getText('Cancel')}</BodySmall>
      </LinkButton>
    </Box>
  </Box>
);

export default IdealistDaysMapAddPinConfirm;
